import React from 'react';
import './Hero.css';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            From Idea to Launch <span className="highlight">Complete Tech & Branding Solutions</span>
          </h1>
          <p className="hero-subtitle">
            Transform your ideas into powerful digital products. We specialize in mobile apps, web development, and cutting-edge UI/UX design that drives growth and engagement.
          </p>
          <div className="hero-buttons">
            <button className="btn-primary" onClick={() => scrollToSection('contact')}>
              Get Started
            </button>
            <button className="btn-secondary" onClick={() => scrollToSection('services')}>
              Our Services
            </button>
          </div>
          <div className="hero-stats">
            <div className="stat-item">
              <h3>100+</h3>
              <p>Projects Delivered</p>
            </div>
            <div className="stat-item">
              <h3>50+</h3>
              <p>Happy Clients</p>
            </div>
            <div className="stat-item">
              <h3>5+</h3>
              <p>Years Experience</p>
            </div>
          </div>
        </div>
        <div className="hero-image">
          <div className="hero-graphic">
            <div className="floating-card card-1">
              <i className="fas fa-mobile-alt"></i>
              <p>Mobile Apps</p>
            </div>
            <div className="floating-card card-2">
              <i className="fas fa-globe"></i>
              <p>Web Solutions</p>
            </div>
            <div className="floating-card card-3">
              <i className="fas fa-palette"></i>
              <p>UI/UX Design</p>
            </div>
            <div className="floating-card card-4">
              <i className="fab fa-apple"></i>
              <p>iOS Development</p>
            </div>
            <div className="floating-card card-5">
              <i className="fas fa-robot"></i>
              <p>AI Chatbots & Smart Tools</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

